import React from "react";
import { useTranslation } from "react-i18next";
import objectivesData from "../data/objectivesData";

export default function ObjectivesSection() {
  const { t } = useTranslation();

  const showObjectives = objectivesData.map((el, index) => (
    <div
      key={index}
      className="h-[275px] bg-[#3793ba96] text-white p-6 rounded-lg shadow-md flex-1 min-w-[250px] mx-2"
    >
      <div className="text-2xl font-bold mb-4">{el.id}</div>
      <div className="text-xl font-semibold mb-2">{t(el.title)}</div>
      <p className="text-sm">{t(el.details)}</p>
    </div>
  ));

  return (
    <section className="objectives-section py-10 bg-gray-100">
      <div className="f-col container h-full px-4 flex justify-center gap-4">
        {showObjectives}
      </div>
    </section>
  );
}
